module.exports = __webpack_public_path__ + "media/images/front/pc/article/doctor01-a5c081d69abbcf6fc138cfb63d429529.png";